import { useCallback } from 'react';
import { ApiError } from './api';
import { showErrorToast } from './toast';

/**
 * Hook returning a standard API error handler used by page controllers.
 *
 * - Unwraps ApiError into a user-facing message (falls back to `fallbackMsg`).
 * - Shows an error toast.
 * - On network errors, the backend may have processed the request but the
 *   response was lost; callers pass `onNetworkError` (typically a `loadData`
 *   function) to resync local state from the server.
 */
export function useApiErrorHandler(onNetworkError?: () => void) {
  return useCallback(
    (err: unknown, fallbackMsg: string) => {
      const msg = err instanceof ApiError ? err.userMessage : fallbackMsg;
      showErrorToast(msg);
      if (
        err instanceof ApiError &&
        err.kind === 'network' &&
        onNetworkError
      ) {
        onNetworkError();
      }
    },
    [onNetworkError],
  );
}
